// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadToDta200ResponseFilesInner
 */
export interface UploadToDta200ResponseFilesInner {
    /**
     * 
     * @type {string}
     * @memberof UploadToDta200ResponseFilesInner
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadToDta200ResponseFilesInner
     */
    uploadUrl?: string;
}

/**
 * Check if a given object implements the UploadToDta200ResponseFilesInner interface.
 */
export function instanceOfUploadToDta200ResponseFilesInner(value: object): value is UploadToDta200ResponseFilesInner {
    return true;
}

export function UploadToDta200ResponseFilesInnerFromJSON(json: any): UploadToDta200ResponseFilesInner {
    return UploadToDta200ResponseFilesInnerFromJSONTyped(json, false);
}

export function UploadToDta200ResponseFilesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadToDta200ResponseFilesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'uploadUrl': json['uploadUrl'] == null ? undefined : json['uploadUrl'],
    };
}

export function UploadToDta200ResponseFilesInnerToJSON(json: any): UploadToDta200ResponseFilesInner {
    return UploadToDta200ResponseFilesInnerToJSONTyped(json, false);
}

export function UploadToDta200ResponseFilesInnerToJSONTyped(value?: UploadToDta200ResponseFilesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'uploadUrl': value['uploadUrl'],
    };
}
